/**
 * Sidebar navigation items for the Employees module.
 * Provides navigation to employee management, out of office, and restrictions.
 * Navigation items are feature-flag gated.
 */
import { SupervisorAccountRounded, SupervisorAccountTwoTone } from '@mui/icons-material';

import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';

export interface EmployeesNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const EmployeesNavItems = (): EmployeesNavItemsResult => {
  const navItems: NavItemType = {
    id: 'employees',
    title: 'Employees',
    type: 'collapse',
    icon: SupervisorAccountTwoTone,
    iconSelected: SupervisorAccountRounded,
    url: '/employees?module=employees',
    featureFlag: FEATURE_FLAGS.EMPLOYEES_MODULE_ENABLED,
    children: [
      {
        id: 'employees_management',
        title: 'Management',
        type: 'item',
        url: '/employees?module=employees&submodule=employees_management'
      },
      {
        id: 'employees_availability',
        title: 'Out of Office',
        type: 'item',
        url: '/employees?module=employees&submodule=employees_availability',
        featureFlag: FEATURE_FLAGS.EMPLOYEES_AVAILABILITY_TAB
      },
      {
        id: 'employees_restrictions',
        title: 'Restrictions',
        type: 'item',
        url: '/employees?module=employees&submodule=employees_restrictions',
        featureFlag: FEATURE_FLAGS.EMPLOYEES_RESTRICTIONS_TAB
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default EmployeesNavItems;
